import React from 'react';
import { useNavigate } from 'react-router-dom';
import ReactCodeInput from 'react-code-input';
import { AuthState } from '../AuthState';
import { CareMapprLayoutBasic } from '../../ai2/layout/Ai2Layout';
import { CodeFormProps } from '../types';
import { Field } from './Field';
import { useEmailVerification } from '../hooks/useEmailVerification';

import 'sweetalert2/dist/sweetalert2.css';
import { baseStyles } from '../styles';

const CodeForm: React.FC<CodeFormProps> = ({ onSubmit }: CodeFormProps) => {
  const navigate = useNavigate();
  const {
    emailRef,
    emailVerifyCode,
    isLoading,
    handleSubmit,
    handleEmailKeyDown,
    emailCodeUpdated,
    handleEmailSubmit,
  } = useEmailVerification(onSubmit);
  if (!isLoading) {
    if (AuthState.email) {
      return (
        <CareMapprLayoutBasic>
          <form style={baseStyles.clientReg} onSubmit={handleSubmit}>
            <h3>Enter the 6-digit code</h3>
            <h3 style={{ marginBottom: '25px' }}>sent to {AuthState.email}</h3>
            <ReactCodeInput
              name="email-code"
              inputMode="numeric"
              fields={6}
              onChange={emailCodeUpdated}
              value={emailVerifyCode}
            />
            <button
              className="btn btnSecondary"
              style={{
                marginLeft: 'auto',
                marginRight: 'auto',
                width: 'fit-content',
                marginTop: '50px',
              }}
              onClick={(event) => navigate('/verify')}
            >
              Back
            </button>
          </form>
        </CareMapprLayoutBasic>
      );
    } else {
      return (
        <CareMapprLayoutBasic>
          <div style={baseStyles.clientReg}>
            <div>Please enter your email address</div>
            <div>
              <Field
                ref={emailRef}
                label="Email"
                type="email"
                onKeyDown={handleEmailKeyDown}
              />
            </div>
            <div>
              <button
                className="btn btnSecondary"
                style={{
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  width: '80px',
                  marginTop: '30px',
                }}
                onClick={(event) => navigate('/login')}
              >
                Back
              </button>

              <button
                className="btn btnPrimary"
                onClick={handleEmailSubmit}
                style={{
                  marginLeft: '90px',
                  marginRight: 'auto',
                  width: '80px',
                  marginTop: '30px',
                }}
              >
                Next
              </button>
            </div>
          </div>
        </CareMapprLayoutBasic>
      );
    }
  } else {
    return (
      <div style={baseStyles.clientReg}>
        <h4>Verifying, please wait...</h4>
      </div>
    );
  }
};

export { CodeForm };
